import { Switch, useLocation } from "react-router";
import { useSelector } from "react-redux";
import Auth from "./components/auth/Auth";
import ApiSetting from "./components/settings/Api-setting";
import Header from "./components/shared/Header";
import { Footer } from "./components/shared/Footer";
import ResetPassword from "./components/auth/pages/ResetPassword";
import PublicRoute from "./components/routes/PublicRoute";
import PrivateRoute from "./components/routes/PrivateRoute";
import Users from "./components/users/Users";
import NotFound from "./components/404";
import CreateUser from "./components/users/UserCreate";
import UserProfile from "./components/users/User-profile";
import Support from "./components/shared/Support";
import Tutorials from "./components/shared/Tutorials";
import UpgradeAccess from "./components/auth/pages/UpgradeAccess";
import ApiKeysPage from "./components/apikeys/ApiKeysPage";
import ComponentPreview from "./components/wireframe/ComponentPreview";
import ProjectList from "./components/builder/ProjectList";
import ProjectCreate from "./components/builder/ProjectCreate";

import WireframeEditor from "./components/builder/WireframeEditor";
import SitemapEditor from "./components/builder/SitemapEditor";
import AppConfig from "./components/builder/AppConfig";
import SubmissionsList from "./components/submissions/SubmissionsList";
import Whitelabel from "./components/settings/whitelabel/Whitelabel";
import TermsOfService from "./components/auth/pages/TermsOfService";
import PrivacyPolicy from "./components/auth/pages/PrivacyPolicy";
import AdminDashboard from "./components/admin/AdminDashboard";
import UserStats from "./components/admin/UserStats";

const AppRouting = () => {
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user_roles = useSelector((state) => state.auth.roles);

  // Hide header and footer on editor pages
  const isEditorPage = location.pathname.startsWith("/builder/create") ||
                       location.pathname.startsWith("/builder/edit") ||
                       location.pathname.startsWith("/builder/sitemap");

  return (
    <>
      {isAuthenticated && !isEditorPage && <Header />}
      <Switch>
        <PublicRoute restricted={true} component={Auth} path="/login" exact />
        <PublicRoute
          restricted={true}
          component={Auth}
          path="/forgot_password"
          exact
        />
        <PublicRoute
          restricted={true}
          component={ResetPassword}
          path="/resetPassword"
          exact
        />
        <PublicRoute component={TermsOfService} path="/terms" exact />
        <PublicRoute component={PrivacyPolicy} path="/privacy" exact />

        <PrivateRoute
          restricted={true}
          component={UpgradeAccess}
          path="/upgrade-access/:plan"
          exact
        />
        {/* Dashboard - Website Builder as main page */}
        <PrivateRoute component={ProjectList} path="/" exact />
        <PrivateRoute component={ProjectList} path="/dashboard" exact />
        <PrivateRoute component={ProjectCreate} path="/builder/create" exact />
        <PrivateRoute component={SitemapEditor} path="/builder/sitemap/:project_id" exact />
        <PrivateRoute component={WireframeEditor} path="/builder/edit/:project_id" exact />
        <PrivateRoute component={AppConfig} path="/builder/app-config/:project_id" exact />
        <PrivateRoute component={ProjectList} path="/builder/:page_no" exact />

        <PrivateRoute component={ApiSetting} path="/settings" />
        <PrivateRoute component={Whitelabel} path="/whitelabel" exact />
        <PrivateRoute component={ApiKeysPage} path="/api-keys" exact />
        <PrivateRoute component={AdminDashboard} path="/admin" exact />
        <PrivateRoute component={UserStats} path="/admin/user/:user_id" exact />
        <PrivateRoute component={SubmissionsList} path="/submissions" exact />
        <PrivateRoute component={ComponentPreview} path="/component-preview" exact />

        <PrivateRoute
          component={CreateUser}
          user_roles={user_roles}
          path="/create-user"
          exact
        />

        <PrivateRoute
          component={Support}
          user_roles={user_roles}
          path="/support"
          exact
        />

        <PrivateRoute
          component={Tutorials}
          user_roles={user_roles}
          path="/tutorials"
          exact
        />

        <PrivateRoute
          component={Users}
          user_roles={user_roles}
          path="/users"
          exact
        />

        <PrivateRoute
          component={Users}
          user_roles={user_roles}
          path="/users/:page_no"
          exact
        />

        <PrivateRoute
          component={CreateUser}
          user_roles={user_roles}
          path="/users/edit/:user_id"
          exact
        />

        <PrivateRoute component={UserProfile} path="/profile" exact />

        <PublicRoute component={NotFound} path="" />
        <PrivateRoute component={NotFound} path="" />
      </Switch>
      {isAuthenticated && !isEditorPage && <Footer />}
    </>
  );
};

export default AppRouting;
